import React, { forwardRef, useCallback, useEffect, } from 'react';
import dayjs from 'dayjs';
import { withNativeProps } from '@/utils/with-native-props';
import { CnPickerView } from '@/components/cn-picker-view';
import { getNearestDate, getRangeDate, getRealRange, isValidDate, toDate, } from '@/utils/date';
import { dateToPicker, DEFAULT_FORMAT, getColumns, getTimeOption, pickerToDate, } from './utils';
import { usePropsValue } from '@/utils/use-props-value';
const EmbedPicker = (props, ref) => {
    const { prefix = 'cn-ui-m-', 
    // value: valueProp,
    // defaultValue,
    onChange, className, hourStep, minuteStep, secondStep, renderTimeMenuItems = (v) => v, format = DEFAULT_FORMAT, 
    // disabledHours,
    // disabledMinutes,
    // disabledSeconds,
    validRange: validRangeProp, } = props;
    const options = getTimeOption(props);
    const validRange = getRealRange(options, props, validRangeProp);
    const isControlled = 'value' in props;
    const [value, setValue] = usePropsValue({
        value: props.value,
        defaultValue: props.defaultValue,
    });
    useEffect(() => {
        function fitValue(v) {
            const d = toDate(v);
            const x = getRangeDate(isValidDate(d) ? d : new Date(), {
                time: options,
            }, validRange);
            if (validRange &&
                (secondStep !== 1 || minuteStep !== 1 || hourStep !== 1)) {
                const xt = dayjs(x).format(format);
                if (xt !== dayjs(validRange[0]).format(format) &&
                    xt !== dayjs(validRange[1]).format(format)) {
                    // 不在边界，将其设置为最靠近的值
                    return getNearestDate(options, props, x, 'auto');
                }
            }
            return x;
        }
        const fit = fitValue(value);
        if (onChange) {
            onChange(fit);
        }
        if (!isControlled) {
            setValue(fit);
        }
    }, [value, isControlled]);
    // Generate selects
    const dataSource = getColumns(value, options, {
        ...props,
    });
    const doRenderTimeMenuItems = useCallback((v) => {
        return v.map((e) => renderTimeMenuItems(e));
    }, [renderTimeMenuItems]);
    const handleChange = (values) => {
        const d = getRangeDate(pickerToDate(values.slice(0), options), {
            time: options,
        }, validRange);
        if (onChange) {
            onChange(d);
        }
        if (!isControlled) {
            setValue(d);
        }
    };
    const pickerValue = dateToPicker(value, options);
    return withNativeProps(props, React.createElement(CnPickerView, { ref: ref, columns: doRenderTimeMenuItems(dataSource), value: pickerValue, className: className, prefix: prefix, onChange: handleChange }, (_, actions) => props.children?.(value, actions)));
};
const CnEmbedPicker = forwardRef(EmbedPicker);
export { CnEmbedPicker };
